module.exports = __webpack_public_path__ + "img/pentagon-fill.6808227c.svg";